<!--
 * @Descripttion: 网格
 * @Author: zenghua.wang
 * @Date: 2021-04-16 13:49:05
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-24 16:38:38
-->
<template>
  <div
    :class="setClass({active: styleActive})"
    :style="styleSize"
  >
    <draggable
      :class="setClass('item', { noborder: disabled })"
      v-for="(_, index) in option.rows * option.cols"
      :key="index"
      :style="styleFlex(index)"
      :list="temp"
      :group="{ name: 'form' }"
      ghost-class="ghost"
      :animation="200"
      :disabled="disabled"
      filter=".drag-grid-item"
      @add="onWidgetGridAdd($event, index)"
    >
      <!-- 网格组件可包含子网格、其他组件 -->
      <template v-if="children[index] && children[index].label">
        <div
          :class="setClass('item__content')"
          :style="styleInline(children[index])"
          @click.stop="onSelectWidgetGrid(index)"
        >
          <!-- 动态组件占位 -->
          <component
            :is="`drag-${children[index].type}`"
            :id="children[index].prop"
            :label="children[index].label"
            :apiId="children[index].apiId"
            :width="children[index].width"
            :height="children[index].height"
            :option="children[index].option"
            :children="children[index].children"
            :temp="children[index].temp"
            :page="children[index].page"
            :index="index"
            :disabled="disabled"
            :select.sync="select"
            @change="$emit('change')"
          >
          </component>

          <div
            :class="setClass('item__action')"
            v-if="selectWidget && selectWidget.prop == children[index].prop &&!disabled"
          >
            <el-button
              title="删除"
              @click.stop="onWidgetGridDelete(index)"
              circle
              plain
              size="small"
              type="danger"
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </div>
        </div>
      </template>

      <div
        v-else
        class="drag-empty"
        :style="styleVisible"
      ></div>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import bem from '@/dragComponents/mixins/bem'
import { component } from '@/dragComponents/model/default.js'
import { isEmpty, createId, deepClone, setPx } from '@/dragComponents/utils'

export default {
  name: 'drag-grid',
  mixins: [bem],
  components: {
    draggable
  },
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    children: {
      type: Array,
      default: () => {
        return []
      }
    },
    temp: {
      type: Array,
      default: () => {
        return []
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectWidget: this.select
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      let rows =
        this.device === 'desktop'
          ? this.option.rows
          : this.option.rows * this.option.cols
      let cols = this.device === 'desktop' ? this.option.cols : 1
      // let rowW = 100 / rows
      // let colW = this.device === 'desktop' ? 100 / cols : 100
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              padding: design.padding,
              background: design.bg,
              border: (() => {
                return this.styleActive ? design.activeSolid : design.solid
              })()
            }
          }
          return {}
        })(),
        {
          gridTemplateRows: `repeat(${rows}, minmax(auto, auto))`,
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gridGap: this.device === 'desktop' ? setPx(this.option.gap) : 0,
          borderRadius: setPx(this.option.borderRadius),
          background: this.option.backgroundColor
        }
      )
    },
    styleActive() {
      return !this.disabled && this.selectWidget.prop === this.id
    },
    styleFlex() {
      const { design } = component
      return (index) => {
        return Object.assign(
          (() => {
            // 设计时
            if (!this.disabled) {
              return {
                minHeight: '100px',
                border: isEmpty(this.children[index]) ? design.dashed : 0,
                background: isEmpty(this.children[index])
                  ? design.emptyBg
                  : 'none'
              }
            }
            return {}
          })(),
          {
            padding: this.device === 'desktop' ? setPx(this.option.padding) : 0
          }
        )
      }
    },
    styleInline() {
      return (item) => {
        let block = (component.inlineList || []).includes(item.type)
          ? 'inline-block'
          : 'block'
        return {
          display: block
        }
      }
    },
    styleVisible() {
      return {
        display: this.disabled ? 'none' : 'block'
      }
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  },
  methods: {
    onWidgetGridAdd(e, gridIndex) {
      let newIndex = e.newIndex
      // 网格中不允许拖入网格
      if (this.temp[newIndex] && this.temp[newIndex].type !== 'grid') {
        const item = deepClone(this.temp[newIndex])
        if (!item.prop) item.prop = createId(item.type)
        this.$set(this.children, gridIndex, item)
        this.$emit('change')
        this.selectWidget = this.children[gridIndex]
      }
    },
    onSelectWidgetGrid(index) {
      this.selectWidget = this.children[index]
    },
    onWidgetGridDelete(index) {
      this.$confirm(`是否删除所选组件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$nextTick(() => {
            if (this.temp) this.temp.splice(index, 1)
            this.$set(this.children, index, {})
            this.$emit('change')
            this.selectWidget = {}
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/dragComponents/styles/variables.scss';

.drag-grid {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: grid;
  grid-template-rows: repeat(1, 100%);
  grid-template-columns: repeat(2, 50%);

  &-item {
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    text-align: left;

    &__content {
      position: relative;
    }

    &__action {
      position: absolute;
      bottom: 0px;
      right: 0px;
      z-index: 1001;

      i {
        font-size: 14px;
      }
    }
  }
}
</style>
